<template>
    <div @click="close">
        <transition name="fade" enter-active-class="animated fadeIn"
                    leave-active-class="animated fadeOut"
                    :duration="300">
            <div class="cover-layer" v-show="isHotCityShow"></div>
        </transition>
        <transition name="bounce" enter-active-class="animated bounceInUp"
                    leave-active-class="animated fadeOut"
                    :duration="500">
            <div class="m-search-content" v-show="isHotCityShow" ref="hotCity">
                    <ul class="content-list">
                        <li class="list-item">
                            <div class="list-content">
                                <div v-for="item in cityData" @click.stop="selectHotel(item)"> {{item.CityName}}</div>
                            </div>
                        </li>
                    </ul>
            </div>
        </transition>
       
    </div>
</template>

<script>
export default {
  name: "HotCity",
  props: {
    isHotCityShow: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      cityData: JSON.parse(this.dao.get('getTFCity'))
    };
  },

  watch: {
    isHotCityShow(val) {
        this.cityData = JSON.parse(this.dao.get('getTFCity'))
    }
  },
  methods: {
    selectHotel(obj) {
      this.$emit("select", obj);
    },
    close(){
      this.selectHotel()
    }
  },
  mounted() {
			var that = this
			that.$nextTick(() => {
        if(localStorage.getItem('lang')=='t'){
          if(localStorage.getItem('lang')=='t'){
            that.$zh_tran(localStorage.getItem('lang'))
          }    
        }
			})
	}
};
</script>

<style scoped>
.m-search-content {
  width: 290px;
  top:40px;
}
.m-search-content .list-item .list-content > div {
  width: 82px;
}

.m-search-content .list-item .list-content > div:hover {
  color: #fff;
  background-color: #28c667;
}
</style>



// WEBPACK FOOTER //
// src/components/regimentRoom/comm/HotCity.vue